export const text = {
  Application: "Applicatie",
  Employees: "Medewerkers",
  "My Team List": "Mijn teamlijst",
  "My Team": "Mijn team",
  "Team Todo": "Team Todo",
  "My Opinion": "Mijn mening",
  "Web Form": "Formulier",
  "My Development": "Mijn ontwikkeling",
  "My Development Goal": "Mijn ontwikkelingsdoel",
  "Assign Goal To Team": "Doel aan team toewijzen",
  "My Development Blog": "Mijn ontwikkeling blog",
  Onboarding: "Onboarding",
  "Onboarding Task": "Onboardingtaak",
  "Onboarding Quiz": "Onboardingquiz ",
  "Onboarding Template": "Onboardingtemplate",
  Academy: "Academy",
  Category: "Categorie",
  Course: "Cursus",
  Lesson: "Les",
  Chapter: "Hoofdstuk",
  Box: "Box",
  "Asset Category": "Middel categorie",
  Asset: "Middel",
  "Book Asset": "Middel boeken",
  News: "Nieuws",
  Agenda: "Agenda",
  "Event Type": "Evenementtype",
  "Calender Event": "Agenda evenement",
  Keys: "Key",
  "Key Folder": "Key map",
  Settings: "Instellingen",
  Report: "Report",
  "Form List": "Form List",
  Article: "Artikel",
  "Read Form": "Formulier lezen",
  Logout: "Uitloggen",
  SwitchLanguage: "Wissel van taal",
  "Form Builder": " ",
  "Add Leave Type": "Verloftype",
  "Add Leave Allowcation": "Verloftoelage",
  Hr: "HR",
  "Leave Settings": "Verlofinstellingen",
  "New Leave Request": "Nieuwe verlofaanvraag",
  "Add Holiday": "Feestdag toevoegen",
  "Add Leave Policy": "Verlofbeleid toevoegen",
  "Leave Block List": "Verlofblokkadelijst",
};
